import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import deLocale from 'element-ui/lib/locale/lang/de'
import frLocale from 'element-ui/lib/locale/lang/fr'
import jaLocale from 'element-ui/lib/locale/lang/ja'
import trLocale from 'element-ui/lib/locale/lang/tr-TR'
import itLocale from 'element-ui/lib/locale/lang/it'
import koLocale from 'element-ui/lib/locale/lang/ko'
import esLocale from 'element-ui/lib/locale/lang/es'
import ruLocale from 'element-ui/lib/locale/lang/ru-RU'
import viLocale from 'element-ui/lib/locale/lang/vi'
import nlLocale from 'element-ui/lib/locale/lang/nl'
import ptLocale from 'element-ui/lib/locale/lang/pt'
import idLocale from 'element-ui/lib/locale/lang/id'
import plLocale from 'element-ui/lib/locale/lang/pl'
import roLocale from 'element-ui/lib/locale/lang/ro'
import bgLocale from 'element-ui/lib/locale/lang/bg'
Vue.use(VueI18n)

const DEFAULT_LANG = 'zh'
const LOCALE_KEY = 'localeLanguage'

const locales = {
  zh: Object.assign(require('./zh.json'), zhLocale),
  // tw: Object.assign(require('./tw.json'), twLocale),
  'zh-TW': Object.assign(require('./tw.json'), twLocale),
  'zh-HK': Object.assign(require('./tw.json'), twLocale),
  'zh-TMO': Object.assign(require('./tw.json'), twLocale),
  en: Object.assign(require('./en.json'), enLocale),
  de: Object.assign(require('./de.json'), deLocale),
  fr: Object.assign(require('./fr.json'), frLocale),
  ja: Object.assign(require('./ja.json'), jaLocale),
  tr: Object.assign(require('./tr.json'), trLocale),
  it: Object.assign(require('./it.json'), itLocale),
  ko: Object.assign(require('./ko.json'), koLocale),
  ru: Object.assign(require('./ru.json'), ruLocale),
  vi: Object.assign(require('./vi.json'), viLocale),
  es: Object.assign(require('./es.json'), esLocale),
  nl: Object.assign(require('./nl.json'), nlLocale),
  pt: Object.assign(require('./pt.json'), ptLocale),
  id: Object.assign(require('./id.json'), idLocale),
  pl: Object.assign(require('./pl.json'), plLocale),
  ro: Object.assign(require('./ro.json'), roLocale),
  bg: Object.assign(require('./bg.json'), bgLocale)
}
const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
})
ElementLocale.i18n((key, value) => i18n.t(key, value))

export const isempty = function(param){
	if(!param){
		return true
	}
	if(typeof(param) == 'number' && param == 0){
		return true
	}
	if(typeof(param) == 'string' && param == ''){
		return true
	}
	if(typeof(param) == 'undefined'){
		return true
	}
	if(typeof(param) == 'object'){
		if(param == null){
			return true
		}
		if(JSON.stringify(param) == '{}' || JSON.stringify(param) == '[]'){
			return true
		}
	}
	if(typeof(param) == 'boolean' && !param){
		return true
	}
	return false
}

export const  getUrlParam = function(e) {
	  var t = new RegExp("(^|&)" + e + "=([^&]*)(&|$)"),
		n = window.location.search.substr(1).match(t);
	  return null != n ? decodeURI(n[2]) : null;
	}

export const getLocale = function() {
  var language = window.navigator.userAgent.match(/Language\/[a-zA-Z]+_[a-zA-Z]+/);
  console.log('window.navigator.userAgent', language)
  if(!isempty(language)){
	language = language[0].split('/')[1]
  }
 
  var urlLocale = getUrlParam('locale')
  if(!isempty(urlLocale)){
    language = urlLocal
  }
  if(isempty(language)){
	language = window.navigator.language || window.navigator.userLanguage
	if(isempty(language)){
	    language = 'zh'
	}
  }
  if(isempty(locales[language])){
    console.log('locales[language]',language ,locales[language])
    language = 'zh'
  }
  if(language == 'in'){
	language = 'id'  
  }
  return language

}

export const setup = lang => {
  if (lang == undefined) {
	let local = getLocale()
	window.localStorage.setItem('locale', local)
	lang = local
  }
  if(window.localStorage.getItem('language')){
	//手动切换的
	lang = window.localStorage.getItem('language')
	window.localStorage.setItem('locale', lang)
  }

  Object.keys(locales).forEach(lang => {
    document.body.classList.remove(`lang-${lang}`)
  })
  document.body.classList.add(`lang-${lang}`)
  document.body.setAttribute('lang', lang)

  Vue.config.lang = lang
  i18n.locale = lang
}


setup()
export default i18n


// WEBPACK FOOTER //
// ./src/locales/index.js